module.exports = __webpack_public_path__ + "img/process-4.ee539102.png";